"use strict";
/**
 * `ModerationMode` — the enum both sides dispatch on, its Zod schema, the
 * order the UI presents the modes in, and the default a new space gets.
 *
 * Lives in shared so the silo's permitted-modes setting and a space's active
 * mode validate against one enum, and so the client can pick its mode-specific
 * UI off the same values the server enforces with.
 *
 * Per-instance storage keeps one boolean key per mode. That codec lives in
 * `server/legacy-data/moderation-mode-storage.ts`, and the keys stay
 * server-side: `moderationMode` is the only representation that crosses the
 * wire.
 *
 * Client-only pieces (silo-setting helpers, UI labels, image map) stay in
 * `client/util/moderation-modes.ts`.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODERATION_MODE_UI_ORDER = exports.moderationModeSchema = exports.ModerationMode = void 0;
exports.getDefaultModerationMode = getDefaultModerationMode;
const z = __importStar(require("zod"));
var ModerationMode;
(function (ModerationMode) {
    ModerationMode["AI_MODERATION"] = "ai_moderation";
    ModerationMode["AI_AND_MANUAL_MODERATION"] = "ai_and_manual_moderation";
    ModerationMode["MANUAL_MODERATION"] = "manual_moderation";
    ModerationMode["AI_MODERATION_WITH_POST_ANYWAY"] = "ai_moderation_with_post_anyway";
})(ModerationMode || (exports.ModerationMode = ModerationMode = {}));
exports.moderationModeSchema = z.enum(ModerationMode);
/**
 * The four modes in the order the UI presents them, per
 * https://www.figma.com/design/5vqFJlKdA6UAQJeXYlMQW2/PSI-Stage-2?node-id=9672-63344&t=nS2JLDeShLQnYaKG-0
 *
 * Load-bearing, and not the enum's declaration order: it decides which mode
 * `getDefaultModerationMode` picks for a new space, and which one wins when a
 * stored instance somehow has two. The client's `moderationModeOptions`
 * renders in this order too.
 */
exports.MODERATION_MODE_UI_ORDER = [
    ModerationMode.AI_MODERATION,
    ModerationMode.AI_MODERATION_WITH_POST_ANYWAY,
    ModerationMode.MANUAL_MODERATION,
    ModerationMode.AI_AND_MANUAL_MODERATION,
];
/**
 * The mode a new space starts in, and the mode a space with no mode stored as
 * on runs in, given the modes a silo permits: the first permitted one in UI
 * order.
 *
 * Falls back to AI moderation when the silo has no setting, and also when it
 * permits nothing at all — a space with no mode would go unmoderated, which is
 * the wrong way to fail.
 */
function getDefaultModerationMode(permittedModes) {
    const permitted = new Set(permittedModes ?? []);
    return exports.MODERATION_MODE_UI_ORDER.find((mode) => permitted.has(mode)) ?? ModerationMode.AI_MODERATION;
}
//# sourceMappingURL=moderation-modes.js.map